
export const generateHowToSchema = (platform: string) => ({
  '@context': 'https://schema.org',
  '@type': 'HowTo',
  name: `How to Download ${platform} Videos`,
  description: `Step-by-step guide to download videos from ${platform}`,
  step: [
    {
      '@type': 'HowToStep',
      name: 'Copy Video URL',
      text: `Navigate to ${platform} and copy the URL of the video you want to download`
    },
    {
      '@type': 'HowToStep',
      name: 'Paste URL',
      text: 'Paste the copied URL into our downloader input field'
    },
    {
      '@type': 'HowToStep',
      name: 'Select Format',
      text: 'Choose your preferred format (MP4, MP3, etc.) and quality'
    },
    {
      '@type': 'HowToStep',
      name: 'Download',
      text: 'Click the download button and save the file to your device'
    }
  ]
});

export const generateBreadcrumbSchema = (items: Array<{name: string, url: string}>) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url
  }))
});
